var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appointment/caldendar-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fill",
    d: "M0.418945 6.19981V9.49981H23.5812V6.19981C23.5812 4.74981 22.4231 3.5498 20.9693 3.5498H3.03085C1.6017 3.5498 0.418945 4.72481 0.418945 6.19981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calenar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0308 25C2.21766 25 1.47844 24.675 0.887064 24.1C0.320329 23.525 0 22.75 0 21.925V6.2C0 4.5 1.35524 3.125 3.0308 3.125H5.1499V0.425C5.1499 0.175 5.34702 0 5.56879 0C5.8152 0 5.98768 0.2 5.98768 0.425V3.1H17.9877V0.425C17.9877 0.175 18.1848 0 18.4066 0C18.6283 0 18.8255 0.2 18.8255 0.425V3.1H20.9446C22.6201 3.1 23.9754 4.475 23.9754 6.175V21.8C23.9754 23.475 22.6201 24.875 20.9692 24.875L3.0308 25ZM3.0308 3.975C1.82341 3.975 0.862423 4.975 0.862423 6.175V21.9C0.862423 22.5 1.08419 23.05 1.50308 23.475C1.92197 23.9 2.46407 24.1 3.05544 24.125L20.9938 24.025C22.1766 24.025 23.1622 23.025 23.1622 21.825V6.2C23.1622 4.975 22.1766 4 20.9938 4H18.8747V5.675C18.8747 5.925 18.6776 6.1 18.4559 6.1C18.2341 6.1 18.037 5.9 18.037 5.675V4H5.98768V5.675C5.98768 5.925 5.79056 6.1 5.56879 6.1C5.32238 6.1 5.1499 5.9 5.1499 5.675V4H3.0308V3.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5811 9.94999H0.418891C0.172485 9.94999 0 9.74999 0 9.52499C0 9.27499 0.197125 9.09999 0.418891 9.09999H23.5811C23.8275 9.09999 24 9.29999 24 9.52499C24 9.74999 23.8029 9.94999 23.5811 9.94999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M10.8916 21.6503C10.7684 21.6503 10.6699 21.6003 10.5713 21.5003L6.80129 17.3253C6.62881 17.1503 6.65345 16.8753 6.82594 16.7003C6.99842 16.5503 7.26947 16.5503 7.44195 16.7253L10.9163 20.5503L18.1606 12.5253C18.3085 12.3503 18.5795 12.3253 18.7767 12.5003C18.9491 12.6503 18.9738 12.9253 18.8013 13.1253L11.2613 21.5003C11.1134 21.6003 10.9902 21.6503 10.8916 21.6503Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheckmark);
export default __webpack_public_path__ + "static/media/Calendar-checkmark.87f6368b.svg";
export { ForwardRef as ReactComponent };